<template>
  <div class="topnav" id="myTopnav">
    <a>
      <select class="form-control" v-model="selectedMode" @change="mode">
        <option value="Dev" selected>Dev</option>
        <option value="prod">Prod</option>
      </select>
    </a>
    <a>View Mode :</a>
    <a href="javascript:void(0);" class="icon" onclick="myFunction()">
      <i class="fa fa-bars"></i>
    </a>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "loginHeader",
  data() {
    return {
      selectedMode: "Dev",
      access: ""
    };
  },
  methods: {
    ...mapActions([
      "getUserData",
      "setMode",
      "currentTab",
      "updateAccess_",
      "clearAccess",
      "updateLoaderStatus"
    ]),

    mode: function() {
      this.getUserData({
        mode: this.selectedMode
      });
      this.pageNumber = 0;
      this.modeSet()
    },
    modeSet: function() {
      this.setMode({ mode: this.selectedMode });
    }
  }
};
</script>

<style>
</style>
